import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useAdminResource } from '../useAdminResource'
import { AdminOrderTable, AdminTotalsStrip } from '../components/AdminOrderTable'
import { money, formatDate } from '../format'
import type { AdminCustomerDetail as Detail } from '../types'

export function AdminCustomerDetail() {
  const { userID = '' } = useParams()
  const [offset, setOffset] = useState(0)
  const [includeArchived, setIncludeArchived] = useState(false)
  const { data: detail, error, busy } = useAdminResource<Detail>(`/api/admin/customers/${encodeURIComponent(userID)}?limit=50&offset=${offset}&includeArchived=${includeArchived}`)

  if (busy && !detail) return <section className="page"><p className="admin-empty">Loading customer…</p></section>
  if (error || !detail) return (
    <section className="page">
      <Link to="/admin/customers" className="back-link"><ArrowLeft size={16} />All customers</Link>
      <div className="form-error" role="alert">{error || 'Customer not found.'}</div>
    </section>
  )

  const { customer, orders } = detail
  return (
    <section className="admin-orders page page--staff">
      <Link to="/admin/customers" className="back-link"><ArrowLeft size={16} />All customers</Link>
      <header className="admin-detail__head">
        <div>
          <div className="eyebrow"><span aria-hidden="true" />Customer</div>
          <h1>{customer.fullName || customer.email}</h1>
          <p>{customer.email} · account since {formatDate(customer.createdAt)} · lifetime charges {money(customer.lifetimeGrossMinor)} (includes archived history)</p>
        </div>
      </header>

      <AdminTotalsStrip totals={orders.totals} />
      <label className="admin-checkbox"><input type="checkbox" checked={includeArchived} onChange={e => { setOffset(0); setIncludeArchived(e.target.checked) }} />Include archived history</label>

      <div className="admin-table-wrap">
        <AdminOrderTable orders={orders.orders} showCustomer={false} />
        {orders.orders.length === 0 && <p className="admin-empty">This account has no orders.</p>}
      </div>
      <nav className="admin-paging" aria-label="Customer orders pagination">
        <span>{orders.totals.count ? `${orders.offset + 1}–${orders.offset + orders.orders.length}` : '0'} of {orders.totals.count} orders</span>
        <button className="button button--outline" disabled={busy || offset === 0} onClick={() => setOffset(Math.max(0, offset - 50))}>Previous</button>
        <button className="button button--outline" disabled={busy || offset + orders.orders.length >= orders.totals.count} onClick={() => setOffset(offset + 50)}>Next</button>
      </nav>
    </section>
  )
}
